import { render } from "./OrderInput.vue?vue&type=template&id=0ec018f0"
import script from "./OrderInput.vue?vue&type=script&lang=js"
export * from "./OrderInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__